<coin-v2-dialog-frame [header]="header">
  <ng-template #header>
    @if (!onlyContent) {
      <h4 class="dialog-title">
        {{
          (data?.mode === dialogMode.Preset
            ? 'season-mgmt.incentive.monitoring.letter-creation.preset-publication-info'
            : 'general.publish'
          ) | translate
        }}
      </h4>
    }
  </ng-template>

  <div class="body-container">
    <div class="selection">
      <coin-v2-dropdown
        matFormFieldClass="shadow"
        [label]="'season-mgmt.incentive.monitoring.letter-creation.select-workflow' | translate"
        [placeholder]="'season-mgmt.incentive.monitoring.letter-creation.click-to-select' | translate"
        [(ngModel)]="selectedWorkflowId"
        (ngModelChange)="loadWorkflowTemplates()">
        @for (item of workflows; track item.id) {
          <ng-template [coinValue]="item.id">
            {{ displayWorkflowFn(item) }}
          </ng-template>
        }
      </coin-v2-dropdown>
      @if (overriddenPublicationDates?.length) {
        <div class="cards-container publication-dates">
          <coin-v2-card
            rounding="extra-large"
            [header]="'season-mgmt.incentive.monitoring.letter-creation.overridden-publication-dates' | translate">
            @for (publicationDate of overriddenPublicationDates; track publicationDate; let i = $index) {
              <coin-v2-date-input
                placeholder="{{ 'general.click-to-select' | translate }}"
                label="{{ publicationDate.fromLetterState | enumToText }} to {{
                  publicationDate.toLetterState | enumToText
                }}"
                [matTooltip]="'season-mgmt.merit.due-date-tooltip' | translate"
                [formControl]="overriddenPublicationDateFormControls[i]" />
            }
          </coin-v2-card>
        </div>
      }
      @if (selection) {
        <div class="options">
          <div class="selection-with-title">
            <div class="employee-selection">
              <p class="bold active">
                <mat-icon>person</mat-icon>
                {{ 'season-mgmt.incentive.monitoring.letter-creation.employee' | translate }}
              </p>
            </div>
            <coin-v2-dropdown
              required
              matFormFieldClass="shadow"
              [disabled]="
                !selectedWorkflowId ||
                noActionWorkflow ||
                onlyManagerWorkflow ||
                managerWorkflowWithEmployeeNotification
              "
              [label]="'season-mgmt.incentive.monitoring.letter-creation.select-task' | translate"
              [placeholder]="'season-mgmt.incentive.monitoring.letter-creation.click-to-select' | translate"
              [(ngModel)]="selection.employeeTask">
              @for (task of employeeTasks; track task) {
                <ng-template [coinValue]="task">{{ displayFn(task) }}</ng-template>
              }
            </coin-v2-dropdown>
            <coin-v2-dropdown
              matFormFieldClass="shadow"
              required
              [disabled]="!selectedWorkflowId || onlyManagerWorkflow"
              [label]="'season-mgmt.incentive.monitoring.letter-creation.select-mail' | translate"
              [placeholder]="'season-mgmt.incentive.monitoring.letter-creation.click-to-select' | translate"
              [(ngModel)]="selection.employeeMail">
              <ng-template [coinValue]="emptyOptionValue">{{ 'general.dropdown-no-option' | translate }}</ng-template>
              @for (mail of employeeMails; track mail) {
                <ng-template [coinValue]="mail">{{ displayFn(mail) }}</ng-template>
              }
            </coin-v2-dropdown>
          </div>
          <div class="selection-with-title">
            <div class="employee-selection">
              <p
                class="bold"
                [class.active]="managerType === managerTypeEnum.LineManager"
                (click)="selectManagerType(managerTypeEnum.LineManager)">
                <mat-icon>person</mat-icon>
                {{ 'season-mgmt.incentive.monitoring.letter-creation.line-manager' | translate }}
              </p>
              <p
                class="bold"
                [class.active]="managerType === managerTypeEnum.CompanyManager"
                (click)="selectManagerType(managerTypeEnum.CompanyManager)">
                <mat-icon>person</mat-icon>
                {{ 'season-mgmt.incentive.monitoring.letter-creation.in-company-manager' | translate }}
              </p>
            </div>

            <coin-v2-dropdown
              required
              matFormFieldClass="shadow"
              [disabled]="!selectedWorkflowId || onlyEmployeeWorkflow || noActionWorkflow"
              [label]="'season-mgmt.incentive.monitoring.letter-creation.select-task' | translate"
              [placeholder]="'season-mgmt.incentive.monitoring.letter-creation.click-to-select' | translate"
              [(ngModel)]="selection.managerTask">
              @for (task of managerTasks; track task) {
                <ng-template [coinValue]="task">{{ displayFn(task) }}</ng-template>
              }
            </coin-v2-dropdown>
            <coin-v2-dropdown
              matFormFieldClass="shadow"
              required
              select-mail
              [disabled]="!selectedWorkflowId"
              [label]="'season-mgmt.incentive.monitoring.letter-creation.select-mail' | translate"
              [placeholder]="'season-mgmt.incentive.monitoring.letter-creation.click-to-select' | translate"
              [(ngModel)]="selection.managerMail">
              <ng-template [coinValue]="emptyOptionValue">{{ 'general.dropdown-no-option' | translate }}</ng-template>
              @for (mail of managerMails; track mail) {
                <ng-template [coinValue]="mail">{{ displayFn(mail) }}</ng-template>
              }
            </coin-v2-dropdown>
          </div>
        </div>
      }
    </div>
  </div>
  @if (!onlyContent) {
    <coin-v2-dialog-footer
      color="white"
      padding="large">
      <coin-v2-button
        type="secondary"
        icon="close"
        iconPos="right"
        [text]="'general.btnClose' | translate"
        (click)="close()"></coin-v2-button>
      <coin-v2-button
        type="primary"
        icon="chevron_right"
        iconPos="right"
        [disabled]="isPublishDisabled"
        [text]="
          (data?.mode === dialogMode.Preset ? 'general.save' : 'season-mgmt.incentive.monitoring.letter-creation.publish')
            | translate
        "
        (click)="publish()"></coin-v2-button>
    </coin-v2-dialog-footer>
  }
</coin-v2-dialog-frame>
